import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from '@campfire-nx/api';

@Pipe({
  name: 'gender'
})

export class GenderPipe implements PipeTransform {
  genderTypes!: Array<string>;

  constructor(
    private configService: ConfigService,
  ) {
    this.genderTypes = this.configService.data?.types.genders; 
  }

  transform(value: any): unknown {
    return this.genderTypes[value] ? this.genderTypes[value] : value;
  }
}
